"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAnnotationSourceReference = exports.isAnnotationDocumentId = exports.ANNOTATION_SERVER_FAILURE = exports.ANNOTATION_CLIENT_TIMEOUT_MS = exports.ANNOTATION_OVERLAY_MAX_BYTES = exports.ANNOTATION_OVERLAY_MAX_EDGE = void 0;
/** Bounded browser overlay protocol. Full-resolution image bytes never cross it. */
exports.ANNOTATION_OVERLAY_MAX_EDGE = 800;
// Shared emits ES2022 JavaScript that the legacy web parsers consume directly.
// Keep these literals free of numeric separators for that build path.
exports.ANNOTATION_OVERLAY_MAX_BYTES = 3000000;
// Longer than the function's 240s timeout, so the client never gives up on a
// save the server can still finish.
exports.ANNOTATION_CLIENT_TIMEOUT_MS = 250000;
exports.ANNOTATION_SERVER_FAILURE = {
    INVALID_REQUEST: 'INVALID_REQUEST',
    NOT_SIGNED_IN: 'NOT_SIGNED_IN',
    SOURCE_FORBIDDEN: 'SOURCE_FORBIDDEN',
    SOURCE_NOT_FOUND: 'SOURCE_NOT_FOUND',
    UNSUPPORTED_SOURCE: 'UNSUPPORTED_SOURCE',
    UNVERIFIED_SOURCE: 'UNVERIFIED_SOURCE',
    IMAGE_TOO_LARGE: 'IMAGE_TOO_LARGE',
    OVERLAY_INVALID: 'OVERLAY_INVALID',
    SERVICE_UNAVAILABLE: 'SERVICE_UNAVAILABLE',
};
const isAnnotationDocumentId = (value) => typeof value === 'string' && /^[A-Za-z0-9_-]{1,128}$/.test(value);
exports.isAnnotationDocumentId = isAnnotationDocumentId;
const isAnnotationSourceReference = (value) => {
    if (!value || typeof value !== 'object' || Array.isArray(value))
        return false;
    const ref = value;
    if (ref.kind === 'upload') {
        return Object.keys(ref).length === 2 && (0, exports.isAnnotationDocumentId)(ref.uploadId);
    }
    return ref.kind === 'result' && Object.keys(ref).length === 4 &&
        (0, exports.isAnnotationDocumentId)(ref.nodeRunId) && (0, exports.isAnnotationDocumentId)(ref.resultUuid) &&
        ref.variant === 'file';
};
exports.isAnnotationSourceReference = isAnnotationSourceReference;
